<style type="text/css" media="screen">
</style>
<template>
  <div>
    <v-row class="mb-5">
      <v-col cols="7" md="6">
        <v-text-field
            v-model="payout_serch_query"
            outlined
            rounded
            dense
            :placeholder="$lang.PAYOUT_SEARCH"
            append-icon="mdi-magnify"
            @keyup="getPayoutList"
            hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="3" md="2" class="text-right">
        <v-btn
            rounded
            depressed
            outlined
            class="download-svg-btn"
            width="151px"
            height=""
            @click="downloadCsv"
        >
          <img src="@/assets/download.svg" alt=""/>
          {{ $lang.DOWNLOAD_CSV }}
        </v-btn>
      </v-col>
      <v-col cols="2" md="1">
        <div
            @click="openFilterDialog"
            class="cursor-pointer w-max-content ml-2"
        >
          <filter-btn :filter_count="payout_filter_data.filter_count"/>
        </div>
      </v-col>
      <v-col cols="12" md="3" class="text-right">
        <v-btn color="primary" @click="openPayoutDialog">
          <b>{{ $lang.INITIATE_PAYOUT }}</b>
        </v-btn>
      </v-col>
    </v-row>
    <div>
      <v-data-table
          :headers="headers"
          :items="payout_list"
          :hide-default-footer="true"
          :disable-sort="true"
          :items-per-page="$keys.PAGE_LENGTH"
          :loading="table_loading"
          show-select
          item-key="order_id"
          v-model="selected"
          class="elevation-1 custome-header-bg custome-table-body"
      >
        <template v-slot:item.employee="{ item }">
          <p>{{ item.agent_name }}</p>
          <p>{{ $lang.MOBILE_PREFIX }}{{ item.agent_phone_number }}</p>
        </template>

        <template v-slot:item.date_time="{ item }">
          <span> {{ item.created_time }}, {{ item.created_date }}</span>
        </template>

        <template v-slot:item.status="{ item }">
          <span :class="item.status.toLowerCase()"> {{ item.status }}</span>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn small fab text @click="gotoPayoutDetails(item)">
            <img src="@/assets/arrow-right.svg" alt=""/>
          </v-btn>
        </template>

        <!-- empty slot  -->
        <template v-slot:no-data>
          <empty-list
              :message="$lang.EMPTY_TRANSACTION"
              :type="$keys.EMPTY_TYPE_2"
          />
        </template>
      </v-data-table>

      <v-pagination
          class="custome-pagination"
          v-model="page_number"
          :total-visible="7"
          :length="total_page_count"
          @input="getPayoutList"
      ></v-pagination>

      <!-- fileter btn -->

      <payout-filter
          :filter_data="filter_data"
          @filter="getPayoutList"
          :filter_dialog="filter_dialog"
      />

      <initiate-payout-dialog
          :dialog="dialog"
          ref="payout_dialog"
          @update="getPayoutList"
      />
    </div>
  </div>
</template>

<script type="text/javascript">
import {mapGetters} from "vuex";

export default {
  components: {
    PayoutFilter: () => import("./child/PayoutFilter.vue"),
    InitiatePayoutDialog: () => import("./child/InitiatePayoutDialog.vue"),
    FilterBtn: () => import("@/components/common-components/FilterBtn.vue"),
  },
  data() {
    return {
      total_page_count: 1,
      page_number: 1,
      table_loading: false,
      payout_list: [],
      selected: [],
      payout_serch_query: "",
      headers: [
        {text: "Transaction ID", value: "order_id"},
        {text: "Employee", value: "employee"},
        {text: "Type", align: "start", sortable: false, value: "agent_type"},
        {text: "Amount", value: "amount"},
        {text: "Time", value: "date_time"},
        {text: "status", value: "status"},
        {text: "", value: "action"},
      ],
      /*FILTER*/
      filter_data: {
        filter_date_from: "",
        filter_date_to: "",
        agent_id_list: [],
        filter_count: 0,
      },
      /* filter dialog */
      filter_dialog: {
        flag: false,
      },
      dialog: {
        flag: false,
        step: 1,
      },
    };
  },
  computed: mapGetters({
    payout_filter_data: "payout/getPayoutFilter",
  }),
  created() {
    this.getPayoutList(false);
  },
  methods: {
    /*Open filter dialog*/
    openFilterDialog() {
      this.filter_data.agent_id_list = this.payout_filter_data.agent_id_list;
      this.filter_data.filter_date_from = this.payout_filter_data.filter_date_from;
      this.filter_data.filter_date_to = this.payout_filter_data.filter_date_to;
      this.filter_data.filter_count = this.payout_filter_data.filter_count;
      this.filter_dialog.flag = true;
    },
    /* fetching shipment list */
    getPayoutList(is_cancel=true) {
      this.$store.dispatch("setPageLoader", true);
      const self = this;
      let params = {
        page_number: this.page_number,
        page_length: this.$keys.PAGE_LENGTH,
        search_query: this.payout_serch_query,
        filter_date_from: this.payout_filter_data.filter_date_from,
        filter_date_to: this.payout_filter_data.filter_date_to,
        filter_agent_id_list: JSON.stringify(
            this.payout_filter_data.agent_id_list
        ),
      };
      self.table_loading = true;

      const successHandler = (response) => {
        console.log(response);
        if (response.data.success) {
          this.payout_list = response.data.transaction_list;
          this.total_page_count = response.data.total_page_count;
        }
      };
      const finallyHandler = () => {
        self.table_loading = false;
        this.$store.dispatch("setPageLoader", false);
      };
      self.request_GET(
          self,
          self.$urls.PAYOUT_HISTORY,
          params,
          successHandler,
          null,
          null,
          finallyHandler,
          is_cancel
    )
      ;
    },
    /* open dialog dialog*/
    openPayoutDialog() {
      console.log("dialog");
      this.$refs.payout_dialog.step = 1;
      this.$refs.payout_dialog.getAgents();
      this.$refs.payout_dialog.otp_value = "";
      this.dialog.flag = true;
    },
    /* Download CSV*/
    downloadCsv() {
      if (this.selected.length == 0) {
        this.showSnakeBar("warning", this.$messages.NO_TRANSACTION_SELECTED);
        return false;
      }
      this.$store.dispatch("setPageLoader", true);
      let payout_id_list = [];
      for (let i = 0; i < this.selected.length; i++) {
        payout_id_list.push(this.selected[i].order_id);
      }
      payout_id_list = JSON.stringify(payout_id_list);
      this.$store.dispatch("setPageLoader", false);
      window.open(
          this.$urls.BASE_URL +
          this.$urls.GET_PAYOUT_CSV +
          "?payout_id_list=" +
          payout_id_list,
          "_blank"
      );
    },
    /* goto payout details*/
    gotoPayoutDetails(item) {
      this.$router.push({
        name: "payout-details",
        params: {order_id: this.encript(item.order_id)},
      });
    },
  },
};
</script>